import { Button, Result } from 'antd';
import React, { Component } from 'react';
import { GridContainer } from 'shared/ui';
import { injectIntl, WrappedComponentProps } from 'react-intl';

interface ErrorBoundaryState {
  hasError: boolean;
}

type ErrorBoundaryProps = {
  children: React.ReactElement;
} & WrappedComponentProps;

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Error caught in ErrorBoundary:', error, info);
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    const { intl } = this.props;
    
    if (this.state.hasError) {
      return (
        <GridContainer>
          <Result
            status="error"
            title={intl.formatMessage({ id: 'errorBoundary.title', defaultMessage: 'Something went wrong' })}
            subTitle={intl.formatMessage({ id: 'errorBoundary.subtitle', defaultMessage: 'Please, refresh page or try again later' })}
            extra={
              <Button type="default" key="refresh" onClick={this.handleRefresh}>
                {intl.formatMessage({ id: 'errorBoundary.refresh', defaultMessage: 'Refresh' })}
              </Button>
            }
          />
        </GridContainer>
      );
    }

    return this.props.children;
  }
}

export default injectIntl(ErrorBoundary);